module.exports = __webpack_public_path__ + "img/logo1.02e964bc.png";